<app-user-header class="d-lg-none"></app-user-header> 


<div class="wrapperi pb-4 ">

    <div class="col-12">

        <div class="pointer" (click)="goBack()">
            <p class="semiboldtextblue16 mb-0"><i class="fal normaltextblue16 fa-chevron-left icon-blue me-2"></i>Takaisin</p>
        </div>
</div>
    <div class="col-12 p-0 row m-0 msg-relative pt-4" *ngIf="isValid && opening">

        <div class="col-12 col-lg-12 p-0 bg-f-w mb-4 formed-shadow">
            <div class="landing-container">
                <div class="d-flex h-100 justify-content-between">
                    <div class="d-flex align-content-center pad-expiracy">
                        <div class="card-container d-fles align-self-center">

                        </div>
                    </div>
                    <div class="">
                    </div>
                </div>
            </div>
            <div class="">
                <div class="justify-content-center">
                    <div class="d-block  p-4">
                        <div class="text-center">
                            <div class="text-center img-margin d-flex justify-content-center">
                                <div class="img-container" >
                                    <div class="img-wrapper border-neutral" *ngIf="opening.profile.profilePicture; else no_image">
                                        <img onerror="this.src='../../assets/icons/formed_no_profile.svg'" src="{{opening.profile.profilePicture}}" class="image-sys" alt="">
                                    </div>
                                    
                                        <ng-template #no_image>
                                            <div class="img-container text-center">
                                                <div class="img-wrapper text-center border-neutral">
                                                    <img src="../../assets/icons/formed_no_profile.svg" class="image-sys" alt="">  

                                                </div>

                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="negotiable-tag" *ngIf="opening.negotiable">
                                        <i class="fal fa-handshake"></i>
                                    </div>
                                    <div class="neg-tag">
                                        <p class="mb-0">Ehdot neuvoteltavissa</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <div class="">
                                <div class="d-flex w-100 justify-content-center">
                                    <div class="">
                                        <p class="semiboldtextblue18 mb-1 text-center">{{opening.profile.mdType.name_fi}}</p>
                                        <p class="normaltextlightblue18 mb-0 text-center">{{opening.profile.firstName}}</p>
                                            <div class="text-center justify-content-center d-flex">
                                                <button class="text-center btn btn-formed-main-blue mt-4 mb-4" (click)="sendMessage()"><i class="fal fa-paper-plane me-2"></i>Lähetä viesti</button>
                        
                                        </div>

                                    </div>
                                </div>
        
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" *ngIf="contacted_by.length > 0">
                        <div class="justify-content-center flex-column flex-lg-row d-lg-flex justify-content-lg-center" *ngFor="let data of contacted_by">
                            <div class=" ps-4 ps-md-0 me-3">
                                <div [ngClass]="opening.can_open ? '' : ''" class=" ms-3 ms-lg-0 justify-content-center align-items-center d-flex">
                                        <p class="cbtext mb-0 "><img class="me-2 mb-1" width="30" height="30" src="../../assets/icons/contactedby.svg"/>{{data.employer.firstName}} kontaktoinut</p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>


            </div>
        </div>
        <div class="col-12 col-lg-12 row p-0 me-0 ms-0 mt-1" *ngIf="opening">
            <div class="col-12 col-md-6 ps-0" *ngIf="type == 'wishlist'">
                <div class="bg-f-w formed-shadow mh-500 border-green">
                    <div class="d-flex justify-content-center">
                        <img width="80" class="formed-wish-image" src="../../assets/images/formed_profile_wish.png" alt="">
                    </div>
                    <div class="p-4 formed-wish-image">
                        <div class="d-flex">
                            <p class="semiboldtextblue80016 mb-0">Toive</p>
                        </div>
                        <div class="ps-4 ps-md-0 flex-column flex-lg-row d-lg-flex flex-wrap mt-2">

                                <div class="p-1">
                                    <div class="gray-box">
                                        <div class="width-20 text-center">
                                            <img src="../../assets/icons/location_blue.svg">
                                        </div>
                                        <p class="semiboldtextblue80016 mb-0 ms-1 sm-m"><span class="ms-2 normaltextblue80016">Sijainti: </span>{{opening.wellfareAreas[0]['name_fi']}}</p>
                                    </div>
                                </div>
                                <div class="p-1">
                                    <div class="gray-box">
                                        <div class="width-20 text-center">
                                            <img src="../../assets/icons/clock_blue.svg">
                                        </div>
                                        <p class="semiboldtextblue80016 mb-0 ms-1 sm-m"><span class="ms-2 normaltextblue80016">Työsuhde: </span>{{opening.workPossibility | workpossibility}}</p>

                                    </div>
                                </div>
                                <div class="p-1">
                                    <div class="gray-box">
                                        <div class="width-20 text-center">
                                            <img src="../../assets/icons/wage_blue.svg">
                                        </div>
                                        <p class="semiboldtextblue80016 mb-0 ms-1"><span class="ms-2 normaltextblue80016">Palkka: </span>{{opening.wage}}<span *ngIf="opening.workPossibility == 'buy-service'">€/h</span>
                                            <span *ngIf="opening.workPossibility != 'buy-service'">€/kk</span></p>
                                    </div>
                                </div>
                                <div class="p-1" *ngIf="opening.remote_only">
                                    <div class="gray-box">
                                        <div class="width-20 text-center">
                                            <img  src="../../assets/icons/remote_blue.svg">
                                        </div>
                                        <p class="semiboldtextblue80016 mb-0 ms-1"><span class="ms-2 normaltextblue80016">Etätyö: </span>Vain etätyö</p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="ps-4 pe-4 pb-4">
                            <p class="semiboldtextblue80016 mb-1">Toiveen kuvaus</p>
                            <p class="normaltextblue80016 allow-line-breaks mb-4">{{opening.description}}</p>
                        </div>
    
                    </div>
                
            </div>
            <div [ngClass]="type == 'wishlist' ? 'col-12 col-md-6 ps-0 ps-md-3' : 'col-12 ps-0'" class=" pe-0 ps-0 ps-md-2 mt-4 mt-md-0">
                <div class="bg-f-w formed-shadow mh-500" *ngIf="(type == 'application' && opening.profile) || type == 'wishlist'">
                    <div class="p-4">
                        <p class="formed-sub-title">Profiili</p>
                        <div class="pb-4 ps-4 ps-md-0 flex-column flex-lg-row d-lg-flex flex-wrap mt-2">
                            <div [ngClass]="opening.can_open ? '' : ''" class=" me-3 ms-lg-0 justify-content-center align-items-center d-flex">
                                    <p class="normaltextblue80016 mb-0 "><img class="me-2 mb-1" width="30" height="30" src="../../assets/icons/prof_exp.svg"/>{{opening.profile.experience}} vuotta kokemusta</p>
                            </div>
                            <div [ngClass]="opening.can_open ? '' : ''" class="me-3 mt-2 mt-lg-0">
                                <div class="d-flex justify-content-center align-items-center d-flex">
                                    <p class="normaltextblue80016 mb-0"><img class="me-2" width="30" height="30" src="../../assets/icons/prof_langs.svg"/>{{opening.profile.languages}}</p>
                                </div>
                            </div>
                            <div [ngClass]="opening.can_open ? '' : ''" class="me-3 mt-2 mt-lg-0 justify-content-center align-items-center d-flex">
                                <p class="normaltextblue80016 mb-0"><img class="me-2" width="30" height="30" src="../../assets/icons/prof_edu.svg"/>{{opening.profile.education}}</p>
    
                            </div>
                            <div *ngIf="opening.profile.is_student || opening.profile.is_specialty" [ngClass]="opening.can_open ? '' : ''" class="me-3 mt-2 mt-lg-0">
                                <div class="d-flex justify-content-center align-items-center d-flex">
                                    <p class="normaltextblue80016 mb-0"><img class="me-2" width="30" height="30" src="../../assets/icons/prof_student.svg"/>
                                        <span *ngIf="opening.profile.is_student">Opiskelija</span>
                                        <span *ngIf="opening.profile.is_specialty">Erikoistuva</span>
    
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="opening.profile.medicine_permissions" [ngClass]="opening.can_open ? '' : ''" class="me-3 mt-2 mt-lg-0">
                                <div class="d-flex justify-content-center align-items-center d-flex">
                                    <p class="normaltextblue80016 mb-0"><img class="me-2" width="30" height="30" src="../../assets/icons/prof_medicines.svg"/>
                                        Lääkeluvat
    
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="opening.profile.julkiterhikki_number" [ngClass]="opening.can_open ? '' : ''" class="me-3 mt-2 mt-lg-0">
                                <div class="d-flex justify-content-center align-items-center d-flex">
                                    <p class="normaltextblue80016 mb-0"><img class="me-2" width="30" height="30" src="../../assets/icons/prof_jt.svg"/>
                                        JulkiTerhikki: {{opening.profile.julkiterhikki_number}}
    
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="" *ngIf="opening.profile.description">
                            <p class="semiboldtextblue80016 mt-2 mb-1">Kuvaus</p>

                                    <p class="normaltextblue80016">{{opening.profile.description}}</p>
            
                        </div>
                                        </div>
                </div>
            </div>
        </div>

  </div>






                    <!-- Modal Check before deleting offer -->
                    <button data-bs-toggle="modal" id="open-profile-btn" data-bs-target="#open-profile-modal" style="display:none"></button>
                    <div class="modal fade" id="open-profile-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered " role="document">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title mt-2" id="exampleModalLabel">Avaa profiili</h5>
                            <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                            <button id="close-open-profile" type="button" id="close-modal-open" class="btn-close" data-bs-dismiss="modal">
                                <i class="fal fa-times"></i>
                                </button>
                        </div>
                        <div class="modal-body">
                            <ng-container *ngIf="prices && prices['application_profile_opening']">
                                <p class="normaltextblue14">Profiilin avaksesta veloitetaan hinnaston mukainen <strong>({{prices['wishlist_profile_opening']['price']}}€ alv.0%)</strong> Profiilin avaus on voimassa <strong>{{prices['wishlist_profile_opening']['days_valid']}} päivää</strong> , jonka aikana voit katsoa ammattilaisen tarkemman profiilin ja lähettää hänelle viestejä. Profiilin avaus on henkilökohtainen organisaatiosi sisällä.
    
                                </p>
    
                                <div class="col-12 row pt-2 me-0 ms-0 mt-4">
                                    <div class="col-2"></div>
                                    <div class="col-8">
    
                                            <div class="card formed-shadow open-card">
                                                <div class="card-body p-2 mt-3">
                                                    <div class="col-12 row m-0">
                
                                                            <div class="">
                                                                <div class="d-flex">
                                                                    <div class="">
    
                                                                        <img src="../../assets/images/formed_locked.png" width="50" height="50" alt="">   
    
                                                                    </div>
                                                                    <div class="ms-2">
                                                                        <p class="semiboldtextblue16 mb-1 "> {{this.opening.profile.mdType.name_fi}}</p>
                                                                        <div class="" *ngIf="this.opening.can_open; else not_opened">
                                                                            <p class="lighttextblue16">{{this.opening.profile.firstName}}</p>
                                                                        </div>
                                                                        <ng-template #not_opened>
                                                                            <p class="lighttextblue16 text-blur">Matti</p>
                
                                                                        </ng-template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="pe-2 ps-2">
                                                                <div class="blue-card">
                                                                        <div class="p-2">
                                                                            <div class="d-flex">
                                                                                <p class="semiboldtextblue16 mb-0 width-20">{{this.opening.profile.experience}}</p>
                                                                                <p class="normaltextblue14 mb-0 ms-1 sm-m">Vuotta kokemusta</p>
                                                                            </div>
                                                                            <div class="d-flex">
                                                                                <p class="semiboldtextblue16 mb-0 width-20">{{this.opening.profile.languages.length}}</p>
                                                                                <p class="normaltextblue14 mb-0 ms-1 sm-m">Puhutut kielet</p>
                                                                            </div>
                                                                        </div>
                                                                 
                                                                </div>
                                                                <div class="pt-3 ps-2">
                                                                    <div class="d-flex">
                                                                        <i class="fal fa-graduation-cap blue-icon me-2"></i>
                                                                        <p class="normaltextblue14 mb-0 ms-1 mb-4">{{this.opening.profile.education}}</p>
                                                                    </div>
                                                                </div>
                                                            </div>     
                                    
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                    <div class="col-2"></div>
                                </div>
    
                                <div class="col-12 pt-3 mt-4">
                                    <div class="col-12" *ngIf="terms_rejected">
                                        <p class="errortext14">Sinun tulee hyväksyä ehdot</p>
                                    </div>
                                    <div class="d-flex ps-4 pe-4">
                                        <div class=" p-0 squaredThree mt-1">
                                            <input type="checkbox" class="unique-class" id="accept_terms" value="checked">
                                            <label class="not-checked" for="accept_terms" id="accept_terms_label"></label>              
                                          </div>
                                        <p class="normaltextblue14 ms-4"><strong>Hyväksyn, että veloitamme sinulta {{prices['wishlist_profile_opening']['price']}}€ alv.0% profiilin avaamisesta</strong></p>
                                    </div>
                                </div>
    
    
     
                                <div id="loader" class="loader-container mt-4" *ngIf="isLoading">
                                    <div class="loader mx-auto"></div>
                                    <p class="text-center pt-3">Tietoja avataan...</p>
                                  </div>
    
    
                            </ng-container>
    
                            
            
                            <div class="text-center justify-content-between d-flex col-12 ">
                                <button class="btn btn-formed-delete mt-2" data-bs-dismiss="modal">Hylkää</button>
                                <button class="btn btn-formed-main-green mt-2" (click)="openProfile()">Hyväksyn</button>
                            </div>
            
                        </div>
                        </div>
                    </div>
                    </div>